var render = function () {
  var _vm$APPLICATION, _vm$APPLICATION$data, _vm$APPLICATION3, _vm$APPLICATION4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-overlay', {
    attrs: {
      "value": _vm.isLoading,
      "z-index": "9999"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "64"
    }
  })], 1), _c('div', [!_vm.ACTUAL_VERSION ? _c('v-alert', {
    staticClass: "error-alert",
    attrs: {
      "max-width": "350",
      "color": "red",
      "dense": "",
      "type": "error"
    }
  }, [_vm._v(" Outdated version of application ")]) : _vm._e(), _c('ApplicationNavigation', {
    attrs: {
      "sections": _vm.sections,
      "user-role": "adviser"
    }
  }), _c('v-row', {
    ref: "sections",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "lg": "9"
    }
  }, [_c('ApplicationSection', {
    key: _vm.applicationSection.key,
    staticClass: "my-6",
    attrs: {
      "section": _vm.applicationSection,
      "existedData": (_vm$APPLICATION = _vm.APPLICATION) === null || _vm$APPLICATION === void 0 ? void 0 : (_vm$APPLICATION$data = _vm$APPLICATION.data) === null || _vm$APPLICATION$data === void 0 ? void 0 : _vm$APPLICATION$data.common
    }
  })], 1)], 1), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isReady,
      expression: "isReady"
    }],
    ref: "sections",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "lg": "9"
    }
  }, _vm._l(_vm.blocks, function (block) {
    return _c('div', {
      key: block.key
    }, [_c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isLoading && block.key !== 'complain',
        expression: "!isLoading && block.key !== 'complain'"
      }],
      staticClass: "block-title"
    }, [_vm._v(" " + _vm._s(block.heading) + " ")]), _vm._l(block.sections, function (section) {
      var _vm$APPLICATION2, _vm$APPLICATION2$data;

      return _c('div', {
        key: section.key
      }, [section.visibility ? _c(section.component, {
        key: section.key,
        tag: "component",
        attrs: {
          "section": section,
          "existedData": (_vm$APPLICATION2 = _vm.APPLICATION) === null || _vm$APPLICATION2 === void 0 ? void 0 : (_vm$APPLICATION2$data = _vm$APPLICATION2.data) === null || _vm$APPLICATION2$data === void 0 ? void 0 : _vm$APPLICATION2$data[section.key]
        },
        on: {
          "componentReady": _vm.componentReady
        }
      }) : _vm._e()], 1);
    })], 2);
  }), 0)], 1), _c('TheBottomNavigation', {
    attrs: {
      "unsavedSections": _vm.IS_UNSAVED_SECTION_EXIST,
      "user-role": "adviser",
      "mainApplicationId": (_vm$APPLICATION3 = _vm.APPLICATION) === null || _vm$APPLICATION3 === void 0 ? void 0 : _vm$APPLICATION3.id
    }
  }, [(_vm$APPLICATION4 = _vm.APPLICATION) !== null && _vm$APPLICATION4 !== void 0 && _vm$APPLICATION4.data ? _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.goToSection('funding_details');
      }
    }
  }, [_vm._v(" LVR"), _c('br'), _vm._v(" " + _vm._s(_vm.LVR) + "% ")]), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goToSection('incomes');
      }
    }
  }, [_vm._v(" Monthly income"), _c('br'), _vm._v(" $ " + _vm._s(_vm.totalMonthlyIncome) + " ")]), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goToSection('incomes');
      }
    }
  }, [_vm._v(" Actual UMI"), _c('br'), _vm._v("$ " + _vm._s(_vm.actualUncommittedMonthlyIncome) + " ")]), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goToSection('incomes');
      }
    }
  }, [_vm._v(" Stressed UMI"), _c('br'), _vm._v("$ " + _vm._s(_vm.UMI) + " ")]), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goToSection('living_expenses');
      }
    }
  }, [_vm._v(" Living Expenses"), _c('br'), _vm._v("$ " + _vm._s(_vm.expensesTotal.toLocaleString()) + " ")]), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goToSection('lender');
      }
    }
  }, [_vm._v(" Mortgage Repayment"), _c('br'), _vm._v("$ " + _vm._s(_vm.mortgageRepayment) + " ")])], 1) : _vm._e()])], 1), _vm.debugEnabled ? _c('div', {
    staticClass: "debug"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "fab": ""
    },
    on: {
      "click": function click($event) {
        _vm.showDebug = !_vm.showDebug;
      }
    }
  }, [_vm._v("?")]), _vm.showDebug ? [_c('div', [_c('b', [_vm._v("Actual Mortgages Total:")]), _vm._v(" $ " + _vm._s(_vm.actualMortgagesTotal) + " ")]), _c('div', [_c('b', [_vm._v("Stressed Mortgages Total:")]), _vm._v(" $ " + _vm._s(_vm.stressedMortgagesTotal) + " ")]), _c('div', [_c('b', [_vm._v("Stressed Mortgage Repayment")]), _vm._v(" $ " + _vm._s(_vm.mortgageRepayment) + " ")]), _c('hr'), _c('div', [_c('b', [_vm._v("Credit Cards Total:")]), _vm._v(" $ " + _vm._s(_vm.creditCardsTotal) + " ")]), _c('hr'), _c('div', [_c('b', [_vm._v("Other Liabilities Total:")]), _vm._v(" $ " + _vm._s(_vm.liabilitiesTotal) + " ")]), _c('hr'), _c('div', [_c('b', [_vm._v("Actual Monthly Repayment:")]), _vm._v(" $ " + _vm._s(_vm.actualMonthlyRepayments) + " ")]), _c('div', [_c('b', [_vm._v("Stressed Monthly Repayment:")]), _vm._v(" $ " + _vm._s(_vm.stressedMonthlyRepayments) + " ")]), _c('hr'), _c('div', [_c('b', [_vm._v("Deposit Source Total:")]), _vm._v(" $ " + _vm._s(_vm.depositValue) + " ")]), _c('hr'), _c('div', [_c('b', [_vm._v("Stressed repayment new purchase:")]), _vm._v(" $ " + _vm._s(_vm.stressedRepaymentNewPurchase(true)) + " ")]), _c('div', [_c('b', [_vm._v("Stressed repayment cons debt:")]), _vm._v(" $ " + _vm._s(_vm.stressedRepaymentConsDebt(true)) + " ")]), _c('div', [_c('b', [_vm._v("Stressed repayment refinance:")]), _vm._v(" $ " + _vm._s(_vm.stressedRefinance(true)) + " ")]), _c('div', [_c('b', [_vm._v("Stressed repayment top up:")]), _vm._v(" $ " + _vm._s(_vm.stressedTopUp(true)) + " ")]), _c('div', [_c('b', [_vm._v("Stressed repayment business loan:")]), _vm._v(" $ " + _vm._s(_vm.stressedBusinessLoan(true)) + " ")]), _c('div', [_c('b', [_vm._v("Total Stressed repayments:")]), _vm._v(" $ " + _vm._s(_vm.totalStressRepayments) + " ")]), _c('hr'), _c('div', [_c('b', [_vm._v("Actual repayment new purchase:")]), _vm._v(" $ " + _vm._s(_vm.stressedRepaymentNewPurchase()) + " ")]), _c('div', [_c('b', [_vm._v("Actual repayment cons debt:")]), _vm._v(" $ " + _vm._s(_vm.stressedRepaymentConsDebt()) + " ")]), _c('div', [_c('b', [_vm._v("Actual repayment refinance:")]), _vm._v(" $ " + _vm._s(_vm.stressedRefinance()) + " ")]), _c('div', [_c('b', [_vm._v("Actual repayment top up:")]), _vm._v(" $ " + _vm._s(_vm.stressedTopUp()) + " ")]), _c('div', [_c('b', [_vm._v("Actual repayment business loan:")]), _vm._v(" $ " + _vm._s(_vm.stressedBusinessLoan()) + " ")]), _c('div', [_c('b', [_vm._v("Total Actual repayments:")]), _vm._v(" $ " + _vm._s(_vm.totalActualRepayments) + " ")]), _c('hr'), _c('div', [_c('b', [_vm._v("Lending required:")]), _vm._v(" $ " + _vm._s(this.fundingSumm) + " ")]), _c('div', [_c('b', [_vm._v("Security value:")]), _vm._v(" $ " + _vm._s(_vm.securityValue) + " ")]), _c('div', [_c('b', [_vm._v("Property Value:")]), _vm._v(" $ " + _vm._s(_vm.propertyValue) + " ")]), _c('div', [_c('b', [_vm._v("LVR:")]), _vm._v(" " + _vm._s(_vm.LVR) + "% ")])] : _vm._e()], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }